var getRowToExpand = function (expanded, prevExpanded) {
    if (!prevExpanded)
        return null;
    var ids = Object.keys(expanded);
    if (ids.length < 2)
        return null;
    var rowToExpand = ids.find(function (id) { return !(id in prevExpanded); });
    return rowToExpand || null;
};
export default getRowToExpand;
//# sourceMappingURL=getRowToExpand.js.map